export default __webpack_public_path__ + "static/media/SEC1920.34I-40943_-24266_0.ba53caf4.jpg";